var React = require('react');

function InviteLink (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"stroke":"#3E424E","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M5.725 2.6l1.352-1.352C7.568.768 8.227.5 8.914.5s1.347.268 1.838.748v0c.48.491.748 1.15.748 1.838 0 .686-.268 1.346-.748 1.837L9.4 6.275M6.775 8.9l-1.352 1.352c-.491.48-1.15.748-1.837.748s-1.347-.268-1.838-.748v0C1.268 9.761 1 9.102 1 8.415s.268-1.347.748-1.838L3.1 5.225M4.15 7.85l4.2-4.2"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("path",{"fill":"#fff","d":"M0 0H12V12H0z"})))]);
}

InviteLink.defaultProps = {"width":"12","height":"12","fill":"none","viewBox":"0 0 12 12"};

module.exports = InviteLink;

InviteLink.default = InviteLink;
